/**
 * Clear all IndexedDB databases used by the application
 * This should be called on logout to prevent data leaking between users
 */
export async function clearAllDatabases(): Promise<void> {
  const databases = [
    "IngredientDB",
    "InventoryDB",
    "PlanDB",
    "PlanTemplateDB",
    "RecipeBookDB",
    "RecipeDB",
    "ShoppingListDB",
    "UnitDB",
  ];

  const deletePromises = databases.map((dbName) => {
    return new Promise<void>((resolve, reject) => {
      const request = indexedDB.deleteDatabase(dbName);

      request.onsuccess = () => {
        console.log(`Successfully deleted database: ${dbName}`);
        resolve();
      };

      request.onerror = () => {
        console.error(`Error deleting database: ${dbName}`, request.error);
        reject(request.error);
      };

      request.onblocked = () => {
        console.warn(`Delete blocked for database: ${dbName}`);
        // Resolve anyway to not block logout
        resolve();
      };
    });
  });

  try {
    await Promise.all(deletePromises);
    console.log("All IndexedDB databases cleared");
  } catch (error) {
    console.error("Error clearing some databases:", error);
    // Don't throw - we still want to complete logout even if some DBs fail to clear
  }
}
